import { Session } from "@/framework/types/Session";

export default {
  navigation: {}, // update navigation bar
  navigationUpdate: {}, // used in voice_to_text -> Duplicate of setNavigation?
  appMode: "", // cs / chat
  isEnableKtznLang: false, // Show lang_cd =KZN in language list or not
  bottomNavigation: {}, // same as bottomNav
  isWeChat: false,
  isLoading: false,
  isSaving: false,
  initialLoading: false,
  closePrivacyPolicyFooter: false,
  isReConnectingNow: false,
  session: {} as Session,
  recievedEventIdList: [],
  isFromLogin: false,
  isRedirected: false,
  checkNotificationPermission: false,
  guestHideHomeIcon: false,
};
